import { render, staticRenderFns } from "./Badges_ArrowScroll.vue?vue&type=template&id=0c75dbfd&scoped=true&"
import script from "./Badges_ArrowScroll.vue?vue&type=script&lang=js&"
export * from "./Badges_ArrowScroll.vue?vue&type=script&lang=js&"
import style0 from "./Badges_ArrowScroll.vue?vue&type=style&index=0&id=0c75dbfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75dbfd",
  null
  
)

export default component.exports